import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NzSkeletonComponent } from 'ng-zorro-antd/skeleton';
import { environment } from '../../../environments/environment';
import { BreadcrumbsComponent } from '../../components/shared/breadcrumbs/breadcrumbs.component';
import { TabBarComponent } from '../../components/shared/tab-bar/tab-bar.component';
import { BreadcrumbModel } from '../../models/breadcrumb.model';
import { SportsService } from '../../services/sport.service';
import { UtilitiesService } from '../../services/utilities.service';
import { DashboardFootballComponent } from './components/dashboard-football/dashboard-football.component';
import { DashboardSportsComponent } from './components/dashboard-sports/dashboard-sports.component';
import { H2hComponent } from './components/h2h/h2h.component';
import { LineupComponent } from './components/lineup/lineup.component';
import { StandingsFootballComponent } from './components/standings-football/standings-football.component';
import { StandingsSportsComponent } from './components/standings-sports/standings-sports.component';
import { StatisticsComponent } from './components/statistics/statistics.component';
import { InfoMatchComponent } from './components/summary-football/info-match/info-match.component';
import { SummaryFootballComponent } from './components/summary-football/summary-football.component';
import { SummarySportsComponent } from './components/summary-sports/summary-sports.component';
import { MatchDetailLive } from './models/match-data.models';
import { ParamsModel } from './models/params.model';
import { MatchDataService } from './services/match-data.service';
import { ROUTE_FOOTBALL, ROUTE_FOOTBALL_EN } from '@/app/routes';
import { ELanguage } from '@/app/utils';
import { TranslationService } from '@/app/services/translation.service';

@Component({
  selector: 'app-match-details',
  standalone: true,
  imports: [
    CommonModule,
    TabBarComponent,
    TranslateModule,
    NzSkeletonComponent,
    BreadcrumbsComponent,
    DashboardFootballComponent,
    DashboardSportsComponent,
    StatisticsComponent,
    LineupComponent,
    SummaryFootballComponent,
    SummarySportsComponent,
    H2hComponent,
    StandingsFootballComponent,
    StandingsSportsComponent,
    InfoMatchComponent,
  ],
  templateUrl: './match-details.component.html',
  styleUrl: './match-details.component.scss',
})
export class MatchDetailsComponent {
  private router = inject(Router);
  private translationService = inject(TranslationService);

  urlIcon = environment.urlIcon;
  urlImg = environment.urlIMG;
  loader = true;
  loading = false;
  loadingBreadCrumb = false;
  infoMatch: MatchDetailLive = {} as MatchDetailLive;
  params: ParamsModel = {} as ParamsModel;
  breadcrumb: BreadcrumbModel = {} as BreadcrumbModel;

  optionsMenuSelected: number = 0;
  optionsSubMenuSelected: number = 0;

  private intervalMatch: any;

  constructor(
    private readonly matchServices: MatchDataService,
    private readonly _activateRoute: ActivatedRoute,
    public readonly utilitiesService: UtilitiesService,
    public readonly sportsServices: SportsService
  ) {}

  ngOnInit(): void {
    if (this.sportsServices.getSelectedSport() === 'Futbol') {
      if (this.translationService.getCurrentLanguage() === ELanguage.EN)
        this.router.navigate([ROUTE_FOOTBALL_EN]);
      else this.router.navigate([ROUTE_FOOTBALL]);
      return;
    }
    this._activateRoute.params.subscribe((params: any) => {
      this.params = params;
    });
    this.getDetailMatch(this.params);
  }

  getDetailMatch(params: ParamsModel) {
    this.matchServices.getMatchDetailSelected(params).subscribe(
      (result: MatchDetailLive) => {
        this.infoMatch = result;
        this.loader = false;
        this.loading = true;
        if (
          (result.score.status.code > 0 && result.score.status.code < 8) ||
          result.statusId === 2
        ) {
          this.refreshMatch();
        } else clearInterval(this.intervalMatch);
      },
      () => {
        this.loader = false;
        this.loading = false;
      }
    );
  }

  menuSelected(event: number) {
    this.optionsMenuSelected = event;
  }
  submenuSelected(event: number) {
    this.optionsSubMenuSelected = event;
  }

  refreshDetailMatch(params: ParamsModel) {
    this.matchServices
      .getMatchDetailSelected(params)
      .subscribe((result: MatchDetailLive) => {
        if (result) {
          this.infoMatch = result;
        }
      });
  }

  refreshMatch() {
    if (
      this.infoMatch.score.status.code === 0 ||
      this.infoMatch.score.status.code >= 9 ||
      this.infoMatch.statusId === 100
    ) {
      clearInterval(this.intervalMatch);
      return;
    }
    const self = this;
    this.intervalMatch = setInterval(function () {
      self.refreshDetailMatch(self.params);
    }, 10000);
  }

  ngOnDestroy(): void {
    clearInterval(this.intervalMatch);
  }
}
